import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { experimentalFeatureCheck } from "./experimentalFeatureHelper";

const EXPERIMENTALROUTETOGGLETYPE = 2;

export const ProtectedRoute: React.FC<
  RouteProps & {
    redirectPath?: string;
    check?: () => boolean;
    experimentalModuleName?: string;
    experimentalFeatureVisibleName?: string;
    experimentalFeatureHiddenName?: string;
    experimentalFeatures?: { [key: string]: any }[];
  }
> = ({
  redirectPath,
  check,
  experimentalModuleName,
  experimentalFeatureVisibleName,
  experimentalFeatureHiddenName,
  experimentalFeatures,
  ...props
}) => {
  const featureToggleVisible =
    experimentalModuleName &&
    experimentalFeatures &&
    experimentalFeatureVisibleName
      ? experimentalFeatureCheck(
          experimentalModuleName,
          experimentalFeatures,
          EXPERIMENTALROUTETOGGLETYPE,
          experimentalFeatureVisibleName
        )
      : true;

  const featureToggleHidden =
    experimentalModuleName &&
    experimentalFeatures &&
    experimentalFeatureHiddenName
      ? experimentalFeatureCheck(
          experimentalModuleName,
          experimentalFeatures,
          EXPERIMENTALROUTETOGGLETYPE,
          experimentalFeatureHiddenName
        )
      : false;

  return (!check || check()) && featureToggleVisible && !featureToggleHidden ? (
    <Route {...props} />
  ) : (
    <Route
      render={(props) =>
        redirectPath ? (
          <Redirect to={`${props.location.pathname}/${redirectPath}`} />
        ) : (
          <Redirect to={`${props.location.pathname}`} />
        )
      }
    />
  );
};
